import { render, staticRenderFns } from "./ChatHeaderSecondary.vue?vue&type=template&id=6a0f9778"
import script from "./ChatHeaderSecondary.vue?vue&type=script&lang=js"
export * from "./ChatHeaderSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports